var App = App || {};

App.ComponentFaqs = (function ($) {
    'use strict';

    function init() {
        Full();
        List();
    }

    function Full() {

        const component = $(".component-faqs-full").first();
        const keys = ["Group", "Tag", "SearchTerm" ];

        if (component.length === 1) {
            keys.every(key => {
                if (App.Base.GetUrlParameter(key) !== "") {
                    $('html, body').animate({
                        scrollTop: component.offset().top
                    }, 300);
                    return false;
                }
                else {
                    return true;
                }
            });
        }
    }

    function List() {

        const component = $(".component-faqs-list");

        component.each(function () {

            const button = $(this).find(".component-faqs-list-additional button");

            button.on("click", function () {

                const target = $("#" + $(this).attr("aria-controls"));

                if ($(this).attr("aria-expanded") == "false") {
                    target.slideDown(300);
                    $(this).attr("aria-expanded", "true");
                }
                else {
                    target.slideUp(300);
                    $(this).attr("aria-expanded", "false");
                }
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ComponentFaqs.init();
});